import ModalMediaComponent from './containers/modalMediaComponent'

export { default as ModalMediaLayout } from './components/modalMediaLayout' 

export default ModalMediaComponent